import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Logs() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listGenerations(100, 0).then(setRows).finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="muted">Loading…</p>;

  return (
    <div>
      <div className="card">
        <h3>Last 100 generations</h3>
        {rows.length === 0 ? (
          <div className="empty">No generations yet. Call <code>POST /api/v1/generate</code> to see logs here.</div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>When</th>
                <th>Status</th>
                <th>Template</th>
                <th>Connector</th>
                <th>Duration</th>
                <th>Generation ID</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="muted mono">{r.created_at}</td>
                  <td>
                    {r.status === 'success'
                      ? <span className="pill success">success</span>
                      : <span className="pill danger">failed</span>}
                  </td>
                  <td className="mono">{r.template_id.slice(0, 8)}</td>
                  <td className="mono">{r.connector_id ? r.connector_id.slice(0, 8) : '—'}</td>
                  <td className="muted">{r.duration_ms}ms</td>
                  <td>
                    {r.output_r2_key
                      ? <a href={`/api/v1/files/${r.id}`} target="_blank" rel="noreferrer" className="mono">{r.id.slice(0, 8)} ↗</a>
                      : <span className="mono muted">{r.id.slice(0, 8)}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
